import { gsap } from "gsap";

/**
 * Click Animation: renders a green dot where the user clicked.
 */
export const dotClick = ({
  event,
  imageElement, // Make imageElement optional
}: {
  event: MouseEvent;
  imageElement?: HTMLImageElement; // Make imageElement optional
}) => {
  if (!imageElement) {
    console.warn("Image element not found, cannot animate.");
    return null;
  }

  const { clientX: clickX, clientY: clickY } = event;
  const imageRect = imageElement.getBoundingClientRect();
  const documentWidth = document.documentElement.clientWidth;
  const DOT_MIN_SIZE_RATIO = 0.3; // 10 % of the document width – adjust here if needed
  const dotSize = Math.max(imageRect.width, documentWidth * DOT_MIN_SIZE_RATIO);

  // Create the dot element
  const dot = document.createElement("div");
  // //console.log(event)
  gsap.set(dot, {
    position: "fixed",
    left: clickX,
    top: clickY,
    width: dotSize,
    height: dotSize,
    backgroundColor: "#0F0",
    borderRadius: "50%",
    xPercent: -50,
    yPercent: -50,
    opacity: 0,
    scale: 1,
    zIndex: 9999,
    pointerEvents: "none",
  });
  document.body.appendChild(dot);

  // Animate the dot
  const tl = gsap.timeline({
    onComplete: () => dot.remove(),
  });

  tl.to(dot, { opacity: 1, duration: 0.1, ease: "power1.out" })
    .to(dot, { scale: 0.5, duration: 0.2, ease: "power1.out" })
    .to(dot, { scale: 0.8, duration: 0.1, opacity: 0, ease: "power1.in" });

  tl.play();
  return tl;
};
